import { makeObservable, observable } from 'mobx';

import { Model } from '../../core/engine';
import { ManyToOne } from '../../core/engine/decorators';
import { Project } from './';

/**
 * One crew position. `email` and `phone` are stored on the position itself so a crew member's
 * details survive even if the linked contact is deleted — the server prefers the live contact
 * when it resolves and falls back to these stored values otherwise. `avatar` is resolved through
 * the contact and is read-only here.
 */
export class CrewMember extends Model {
  projectId: string;

  name = '';

  role = '';

  department = '';

  team = '';

  email = '';

  phone = '';

  avatar = '';

  /** null when the position is not filled yet. */
  contactId: string | null = null;

  order = 0;

  @ManyToOne('crewMembers')
  project: Project;

  constructor() {
    super('crewMembers');

    makeObservable<CrewMember>(this, {
      name: observable,
      role: observable,
      department: observable,
      team: observable,
      email: observable,
      phone: observable,
      avatar: observable,
      contactId: observable,
      order: observable,
      project: observable,
    });
  }

  get isAssigned(): boolean {
    return !!this.contactId;
  }

  toPOJO(): Record<string, any> {
    return {};
  }

  static getOne(id: string): CrewMember | undefined {
    return Model.getOne(id) as CrewMember;
  }
}
